import {PERMISSION_TYPE} from '../../Permissions';
import {hasPermission} from '../../forecast-app/shared/util/PermissionsUtil';

const VIEW_USER_RE = /^\/admin\/team\/view-user\/[^/]+$/;
const PROJECT_ROOT_RE = /^\/project\/([^/?#]+)\/?$/;
const PROJECT_SUBPAGE_RE = /^\/project\/([^/?#]+)\/([^/?#]+)/;

/**
 * Whether the viewer may open the project financials page. Mirrors the `project-budget` route access in
 * `Util.AuthorizeViewerAccess`, which is the source of truth: either financial permission, full or revenue only.
 * Viewers without it are sent to the task board instead.
 */
export function canViewProjectFinancials(): boolean {
	return (
		hasPermission(PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION) ||
		hasPermission(PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE)
	);
}

export function normalizeChatLink(href: string, canViewFinancials: boolean): string {
	if (VIEW_USER_RE.test(href)) {
		return '/scheduling#people';
	}
	const root = href.match(PROJECT_ROOT_RE);
	if (root) {
		return canViewFinancials ? `/project/${root[1]}/financials#details` : href;
	}
	const sub = href.match(PROJECT_SUBPAGE_RE);
	if (!sub) {
		return href;
	}
	const [, slug, subpage] = sub;
	// The budget route is gated like financials; without the permission both open the task board.
	const isFinancialsRoute = subpage === 'financials' || subpage === 'budget';
	if (!canViewFinancials) {
		return isFinancialsRoute ? `/project/${slug}` : href;
	}
	return subpage === 'financials' ? href : `/project/${slug}/financials#details`;
}
